import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react'

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!PUBLISHABLE_KEY) {
    throw new Error("Missing Publishable Key")
}

const theme = createTheme();

const panelStyle = {
    fontFamily: "monospace",
    padding: "24px",
    margin: "24px auto",
    maxWidth: "900px",
    border: "1px solid #d32f2f",
    borderRadius: "4px",
    background: "#fff5f5",
    color: "#3c1414",
};

const preStyle = {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontSize: "12px",
    background: "#ffffff",
    padding: "12px",
    border: "1px solid #f0c0c0",
    borderRadius: "4px",
    maxHeight: "50vh",
    overflow: "auto",
};

// Render-time TypeErrors used to produce a blank white page with nothing in the
// UI to explain it. Anything that throws below this point now shows up here.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, componentStack: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Unhandled render error", error, errorInfo);
        this.setState({ componentStack: errorInfo && errorInfo.componentStack });
    }

    render() {
        if (!this.state.error) {
            return this.props.children;
        }

        const { error, componentStack } = this.state;

        return (
            <div style={panelStyle}>
                <h2>The app crashed while rendering.</h2>
                <p>{error.message || String(error)}</p>
                <pre style={preStyle}>{error.stack || ""}{componentStack || ""}</pre>
                <button type="button" onClick={() => window.location.reload()} style={{ padding: "8px 16px", fontSize: "14px" }}>
                    Reload page
                </button>
            </div>
        );
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

if (!BACKEND_URL) {
    // Mirrors the publishable-key guard above, but rendered instead of thrown so
    // the operator sees the reason rather than a blank page.
    console.error("Missing REACT_APP_BACKEND_URL - every backend call would hit 'undefined/...'");
    root.render(
        <div style={panelStyle}>
            <h2>Missing Backend URL</h2>
            <p>REACT_APP_BACKEND_URL is not set, so every backend call would be made against "undefined/...".</p>
            <p>Set it in the environment and rebuild the frontend.</p>
        </div>
    );
} else {
    console.info(`[boot] Backend URL: ${BACKEND_URL}`);
    root.render(
        <ErrorBoundary>
            <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
                <ThemeProvider theme={theme}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </ThemeProvider>
            </ClerkProvider>
        </ErrorBoundary>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
